export default "__VITE_ASSET__BT3Is1QS__"